<section fxLayoutAlign="center center" class="roster-course-language-form">
  <div fxLayout="column" fxFlex="90%">
    <mat-card appearance="outlined">
      @if (!languagesLoaded) {
        <mat-spinner></mat-spinner>
      }
      @if (languagesLoaded) {
        <div>
          <div class="roster-course-masthead">
            <h3 class="roster-course-header">
              Welcome@if (user) {
              <span>, {{ user?.firstName }}</span
                >
                }!
              </h3>
              @if (!zeroLanguage) {
                <p class="roster-course-description">
                  We've detected classes with incomplete information.
                  Please update your classes with the missing information
                  below.
                </p>
              }
              @if (zeroLanguage) {
                <p class="alert">
                  No programs have been added to your school, please
                  contact customer support or your local district admin to
                  fix this!
                </p>
              }
            </div>
            @if (!zeroLanguage) {
              <div>
                <h4 class="roster-course-language-subhead">
                  {{ activeCoursesData.length }} classes detected
                </h4>
                <mat-accordion class="roster-course-language-panels">
                  @for (course of activeCoursesData; track course; let i = $index) {
                    <mat-expansion-panel
                      [expanded]="i === 0"
                      >
                      <mat-expansion-panel-header>
                        <mat-panel-title
                          class="roster-course-language-panel-header"
                          >
                          <span class="header">
                            <span
                              class="class-color-square"
                                            [ngClass]="
                                                course.courseColor || 'bvg-blue'
                                            "
                            ></span>
                            {{ course.courseTitle }}
                          </span>
                          <span class="archiveFlag">
                            <mat-checkbox
                              class="example-margin"
                                            [(ngModel)]="
                                                currentObj[course.courseID]
                                                    .archive
                                            "
                              labelPosition="after"
                              matTooltip="Select if license is unavailable or class is not a Passport class"
                              (click)="accordion.closeAll();completenessFlag(course);$event.stopPropagation();"
                              >
                              Archive Class &nbsp;|&nbsp;&nbsp;
                            </mat-checkbox>
                          </span>
                          <span
                            class="completeFlag"
                                        [ngClass]="{
                                            incomplete:
                                                completenessFlag(course) ===
                                                'Incomplete'
                                        }"
                            >{{ completenessFlag(course) }}</span
                            >
                            <span class="dates"
                              >Start Date:
                              {{ course.startDate | customDate }} |
                              End Date:
                              {{ course.endDate | customDate }}</span
                              >
                            </mat-panel-title>
                            <ng-template matExpansionPanelContent>
                              <p class="teacherSchoolRow">
                                <span class="teacherSchoolLabel"
                                  >Teacher:
                                  <span>{{
                                    course.primaryTeacher.fullName
                                  }}</span></span
                                  >
                                  <span class="teacherSchoolLabel"
                                    >School:
                                    <span>{{
                                      schoolName
                                    }}</span></span
                                    >
                                  </p>
                                  <div class="roster-course-language-fields">
                                    @if (
                                      activeLanguages.length &&
                                      currentObj &&
                                      currentObj[course.courseID]
                                      ) {
                                      <mat-select
                                            [(ngModel)]="
                                                currentObj[course.courseID]
                                                    .language
                                            "
                                            (selectionChange)="
                                                setLanguageForOneCourse(
                                                    $event,
                                                    course.courseID
                                                )
                                            "
                                        placeholder="Program"
                                        appearance="outline"
                                        [disabled]="currentObj[course.courseID].archive"
                                        >
                                        @for (
                                          language of activeLanguages; track trackByLanguageID($index,
                                          language)) {
                                          <mat-option
                                            [value]="language"
                                            >
                                            {{ language.languageName }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    }
                                    @if (
                                      currentObj &&
                                      currentObj[course.courseID]
                                      .language
                                      ) {
                                      <mat-select
                                            [(ngModel)]="
                                                currentObj[course.courseID]
                                                    .levelLabel
                                            "
                                        (selectionChange)="checkLevels();completenessFlag(course);"
                                            placeholder="{{
                                                currentObj[course.courseID]
                                                    .language?.levelLabel
                                            }}"
                                        [attr.aria-placeholder]="levelLabel"
                                        [attr.aria-label]="levelLabel"
                                        >
                                        @for (
                                          level of getLevels(
                                          currentObj[
                                          course.courseID
                                          ]
                                          )
                                          ; track
                                          level) {
                                          <mat-option
                                            [value]="level.levelId"
                                            >
                                            {{ level.levelName }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    }
                                    @if (
                                      currentObj &&
                                      currentObj[course.courseID]
                                      .language &&
                                      isMath(
                                      currentObj[course.courseID]
                                      .subjectId
                                      )
                                      ) {
                                      <mat-select
                                            [(ngModel)]="
                                                currentObj[course.courseID]
                                                    .classProfile
                                            "
                                        (selectionChange)="checkLevels()"
                                        placeholder="Class Profile"
                                        aria-placeholder="Class Profile"
                                        aria-label="Class Profile"
                                        >
                                        @for (
                                          profile of classProfiles
                                          ; track
                                          profile) {
                                          <mat-option
                                            [value]="profile.id"
                                            >
                                            {{ profile.value }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    }
                                    <mat-slide-toggle
                                      color="primary"
                                            (change)="
                                                setLanguageForAllCourses(
                                                    $event,
                                                    course
                                                )
                                            "
                                      [(checked)]="selectAllObj.checked"
                                            [disabled]="
                                                applyAllDisabled(course)
                                            "
                                      >Apply same information to all
                                      classes
                                    </mat-slide-toggle>
                                  </div>
                                </ng-template>
                              </mat-expansion-panel-header>
                            </mat-expansion-panel>
                          }
                        </mat-accordion>
                      </div>
                    }
                  </div>
                }
                <mat-card-actions class="roster-course-language-actions">
                  @if (!zeroLanguage) {
                    <button
                      type="submit"
                      mat-raised-button
                      color="primary"
                      [disabled]="submitDisabled()"
                      (click)="ok()"
                      >
                      {{ saveText }}
                    </button>
                  }
                  @if (showWarning) {
                    <p>
                      * Every class must have a program and level
                    </p>
                  }
                </mat-card-actions>
              </mat-card>
            </div>
          </section>
